import styled from 'styled-components';

export const BlurContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  backdrop-filter: blur(4px);
`;

export const CodeContainer = styled.div`
  background: #FFF;
  max-width: 800px;
  min-height: 200px;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  object-fit: cover;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 24px;
  align-items: center;
  gap: 24px;
`;

export const CodeTitle = styled.span`
  color: #1C1C1C;
  font-size: 18px;
  line-height: 1.5; 
  font-weight: 400;
  text-align: center;
  max-width:80%
`;
